<template>
  <b-container id="main-container" fluid style>
    <b-row style="width: 100%; background-color: #e8e8ea" align-h="center">
      <b-col class="" cols="12">
        <nav-header></nav-header>
      </b-col>
    </b-row>

    <b-row style="width: 100%; margin-top: 60px" align-h="center">
      <b-col
        cols="12"
        style="max-width: 1200px; padding-top: 40px; padding-bottom: 100px"
        class="term_service"
      >
        <h1 style="text-align: center">Truthbrush Distributor Policy</h1>
        <hr style="width: 100%; border: 0.5px solid gray" />
        <p>
          Thanks for your interest in becoming an Authorized Truthbrush
          Distributor! For inquiries around becoming a domestic distributor
          within United States, please email
          <a href="mailto:e@candibell.com">e@candibell.com</a>. For information
          on becoming an international distributor including Canada, please
          email <a href="mailto:sale@candibell.com">sale@candibell.com</a>.
        </p>

        <p>
          Truthbrush hereby announces its Distributor Policy (the “Policy”) with
          the goals of ensuring authorized distributors (the “Distributor”) can
          sustain healthy margins on the Truthbrush products and the end-users
          are being provided with a quality sales experience and customer
          support.
        </p>
        <p>
          Truthbrush believes that its end-user customers are best served by
          having distributors who market Truthbrush’s products as premium brand
          products and who provide an outstanding level of service and support
          to their end-user customers. Therefore, Truthbrush asks distributors
          to comply with the following terms and conditions:
        </p>

        <ul>
          <li>
            <b>Internet Sales Prohibited.</b> Distributor shall be prohibited from
            selling Truthbrush Products on the Internet unless
            approved by Truthbrush, and executes an Authorized Internet
            Distributor Agreement or other similar agreement regulating the
            manner in which it sells online;
          </li>
          <li>
            <b>No Transshipping.</b> Distributor shall not transship Products.
            Specifically, Distributor shall not sell, transfer, or offer for
            sale any Product(s) to any person or entity for resale;
          </li>
          <li>
            <b>Sales to End Users Only.</b> Unless otherwise agreed with Truthbrush in
            writing, Distributor may only purchase Products for resale to
            consumers and end user customers, and Distributor may not resell
            Products to other Distributors, distributors or for further
            distribution in any manner;
          </li>
          <li>
            <b>Geographic Sales Boundary.</b> Distributor may only sell and advertise
            for sale Truthbrush Products within their assigned geographic sales
            boundary. Truthbrush hereby expressly prohibits the Distributor from
            soliciting or consummating sales outside of the assigned geographic
            sales boundary;
          </li>
          <li>
            <b>Intellectual Property.</b> The unauthorized use of the intellectual
            property of Truthbrush is prohibited. Distributors that comply with
            this Policy have a limited, non-exclusive, non-sublicensable,
            revocable license to use Truthbrush’s trademarks and copyrights in
            connection with the sale of the Products. Distributor shall not
            alter, modify, or change any trademark or copyright, nor shall
            Distributor use any trademark or copyright other than for the
            promotion and sale of the Products, nor shall Distributor use any
            trademark or copyright in any manner that negatively impacts such
            trademark or copyright or the Truthbrush. Failure to comply with the
            Policy will result in the automatic revocation of the license
            granted herein and a total forfeiture of the rights granted herein.
            Truthbrush reserves the right to revoke this license at any time for
            any or no reason;
          </li>
          <li>
            <b>Sales Practices.</b> Distributor shall conduct its business in a
            reasonable and ethical manner at all times and shall neither engage
            in any deceptive, misleading, or unethical practices or advertising
            at any time, nor make any warranties or representations concerning
            the Products except as expressly authorized by Truthbrush.
            Distributor shall comply with any and all applicable laws, rules,
            regulations, and policies related to the advertising, sale, and
            marketing of Truthbrush Products;
          </li>
          <li>
            <b>Service.</b> Distributor shall provide the highest levels of customer
            service. Distributor and Distributor’s sales personnel shall be
            familiar with the special features of all Truthbrush Products
            marketed for sale and must obtain sufficient product knowledge to
            advise customers on the selection and safe use of the products, as
            well as any applicable warranty, guarantee, or return policy;
          </li>
          <li>
            <b>Product Packaging.</b> Distributor shall sell Truthbrush Products in
            their original packaging. Relabeling, repackaging (including the
            separation of bundled products or the bundling of separate
            products), and other alterations are not permitted, unless approved
            by Truthbrush. Tampering with, defacing, or otherwise altering any
            serial number, UPC code, batch or lot code, or other identifying
            information on Products or their packaging is prohibited.
            Distributor shall not remove, translate, or modify the contents of
            any label or literature on or accompanying the Products;
          </li>
          <li>
            <b>Recall and Consumer Safety.</b> To ensure the safety and well-being of
            the end users of the Products, Distributor agrees to cooperate with
            Truthbrush with respect to any Product recall or other consumer
            safety information dissemination efforts;
          </li>
          <li>
            <b>Product Loss and Theft.</b> If any significant quantity of Products
            purchased by Distributor are lost or stolen, Distributor will
            promptly report such event to Truthbrush;
          </li>
          <li>
            <b>Report Unauthorized Distributors.</b> If Distributor has information or
            reasonably suspects that any person is purchasing and reselling or
            distributing Products in a manner not authorized by Truthbrush or in
            violation of this Policy, Distributor must promptly notify
            Truthbrush;
          </li>
          <li>
            <b>Support of Manufacturer’s Warranty.</b> Distributor may extend to any
            proper purchaser of the Products the original manufacturer’s
            warranty in accordance with its terms. Distributor may not modify or
            alter the original manufacturer’s warranty, represent or
            characterize the original manufacturer’s warranty in any misleading
            manner, or extend its own warranty with respect to the Products.
            Failure to comply with this Policy will result in the total
            forfeiture of Distributor’s right to offer Truthbrush’s consumer
            warranty;
          </li>
          <li>
            <b>Other Information, Documents and Reports.</b> Distributor must provide
            Truthbrush with any supplemental information, documents and reports
            that Truthbrush may request in order to validate Distributor’s
            compliance with this Policy and to support Truthbrush’s warranty
            support and customer support obligations and initiatives.
          </li>
        </ul>

        <p>
          Truthbrush reserves the right to update, amend, or modify this Distributor Policy at any time. Unless otherwise provided, such amendments will take effect immediately and Distributor’s continued use, advertising, offering for sale, or sale of the Products will be deemed Distributor’s acceptance of the amendments.
        </p>
        <p>
          If Truthbrush determines that Distributor is in violation of this Distributor Policy, Truthbrush may take any and all appropriate legal actions, including, but not limited to refusing to, accept orders from Distributor or instructing its distributors to refuse to accept orders from Distributor.
        </p>
      </b-col>
    </b-row>

    <b-row style="width: 100%">
      <nav-footer></nav-footer>
    </b-row>
  </b-container>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
export default {
  name: "Home",
  components: {
    NavHeader,
    NavFooter,
  },
};
</script>

<style lang="scss">
.term_service h2 {
  padding-top: 15px;
}

@media (max-width: 768px) {
  .term_service h2,
  .term_service h4 {
    text-align: center;
  }
}
</style>